import { Controller, Loader, IDynamicLoader } from '@tencent/workbench';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/text/font/back-color/config';
import { Form } from '@tencent/wb-ext-form';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { IBackColorFeature } from './back-color-interface';
import { BackColorFeature } from '@framework/workbench/ui/back-color/back-color-feature';
import { TDWVer6Type } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';

@Controller({ formItems: FORM_CONFIGS })
export class BackColorFormController {
    constructor(
        @Loader(IBackColorFeature) private loader: IDynamicLoader<IBackColorFeature>,
        @Loader(BackColorFeature) private loader2: IDynamicLoader<BackColorFeature>,
    ) {}

    private get feature() {
        return this.loader.instance!;
    }

    private get feature2() {
        return this.loader2.instance!;
    }

    @Form(FormItemName.FONT_BACK_COLOR, 'content')
    public renderItemNum() {
        return this.feature.renderItemNum(this.feature2.getBackColorDropDownContent(TDWVer6Type.COLOR_PICKER_DRAWER));
    }
}
